import { Breakpoints, styled, Layout } from '@volkswagen-onehub/components-core';
import { LegalesFormatoLayer, LssiTkmQuestions, PoliticaPrivacidad, LastNavigation, GeneralConfirmacionLayerWrapper } from 'src/components';
import React from 'react';

export const ConfirmacionProspects = () => {

  return (
    <GeneralConfirmacionLayerWrapper>
      <Layout
        appearance={{
          [Breakpoints.default]: [
            { name: '.', columns: 2 },
            { name: 'a', columns: 20 },
            { name: '.', columns: 2 },
          ],
          [Breakpoints.b960]: [
            { name: '.', columns: 3 },
            { name: 'a', columns: 18 },
            { name: '.', columns: 3 },
          ],
        }}
        allowOverflowingContent
      >
        <LssiTkmQuestions title />
        <PoliticaPrivacidad />

        <LastNavigation />
        <LegalesFormatoLayer noPadding={false} title={true} />
      </Layout>
    </GeneralConfirmacionLayerWrapper>
  );
};
